module.exports = __webpack_public_path__ + "img/succeedLenders.9f0ec39d.png";